import Blue from '~/core'

new Blue({
  name: 'Footer',
  selector: '.footer',
  setup(footer) {
    const containers = [...footer.querySelectorAll('.footer__column')]

    containers.forEach((container) => {
      const trigger = container.querySelector('.footer__title')
      const content = container.querySelector('.footer__list')

      const accordion = new this.$toggle({
        container,
        trigger,
        content,
        props: ['visibility', 'opacity', 'height'],
        externalEvents: true,
      })

      const adjustTabIndex = () => {
        if (this.$screen.lg.matches) {
          trigger.removeAttribute('tabindex')
        } else {
          trigger.setAttribute('tabindex', 0)
        }
      }

      adjustTabIndex()
      this.$screen.md.addEventListener('change', adjustTabIndex)

      this.$addEvents(trigger, 'click.stop.prevent enter.stop.prevent', () => {
        if (!this.$screen.lg.matches) {
          accordion.toggle()
        }
      })
    })
  },
})
